import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZCreateDeviceApiResponse = z.object({
  id: z.string().optional(),
  asset_id: z.string().optional(),
  name: z.string()
})

export interface CreateDevicePostRequest {
  type?: string
  name: string
  description?: string
  device_tag?: string
  serial_number: string | null
  application_type: string
  install_date: string
  slave_id: string
  latitude: string | number
  longitude: string | number
  asset_type_id?: string
  asset_model_id?: string
  asset_category_id?: string
  parent_asset_id?: string
  site_id?: string
  modem_id?: string
}

const ZApiResponse = z.object({
  http_status: z.number(),
  data: ZCreateDeviceApiResponse,
  error: z.boolean()
})

export type CreateDeviceApiResponse = z.infer<typeof ZCreateDeviceApiResponse>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function createDevice (
  createDevicePostRequest: CreateDevicePostRequest,
  onSuccess: (successResponse: CreateDeviceApiResponse, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = '/assetrest/api/v2/udp/tiq/assets'

  interceptedAxios
    .post(url, createDevicePostRequest, { timeout: 15000 })
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)

      if (parseResponse.success) {
        onSuccess(parseResponse.data.data, parseResponse.data.http_status)
      } else {
        onFailure('Error occurred while processing response', response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
